<template>
	<div>
		<div class="register-wrapper">
			<div id="register">
				<p class="title">会员注册</p>
				<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="0" class="demo-ruleForm">
					<el-form-item prop="email">
						<el-input v-model="ruleForm2.email" auto-complete="off" placeholder="请输入邮箱"></el-input>
					</el-form-item>
					<el-form-item prop="name">
						<el-input v-model="ruleForm2.name" auto-complete="off" placeholder="请输入昵称"></el-input>
					</el-form-item>
					<el-form-item prop="contact_address ">
						<el-input type="text" v-model="ruleForm2.contact_address" auto-complete="off" placeholder="请输入联系地址"> </el-input>
					</el-form-item>
					<el-form-item prop="tel">
						<el-input v-model="ruleForm2.tel" auto-complete="off" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item prop="domain">
						<el-input v-model="ruleForm2.domain" auto-complete="off" placeholder="团队ID，2-32位英文或数字"></el-input>
					</el-form-item>
					<el-form-item prop="full_name">
						<el-input v-model="ruleForm2.full_name" auto-complete="off" placeholder="公司名称"></el-input>
					</el-form-item>
					<el-form-item prop="smscode" class="code">
						<el-input v-model="ruleForm2.smscode" placeholder="请输入验证码" style="width: 57%; position: relative; right: 60px"></el-input>
						<img :src="captchaSrc" alt="" style="width: 35%; height: 35px" @click="refresh()" />
					</el-form-item>
					<div class="agree">
						<el-checkbox v-model="ruleForm2.agree"> </el-checkbox>
						我已阅读并同意
						<!-- 可点击的协议链接 -->
						<a href="/console.html#/user-agreement" target="_blank" class="link">用户协议</a>、
						<a href="/console.html#/privacy-policy" target="_blank" class="link">隐私政策</a>
					</div>
					<el-form-item>
						<el-button type="primary" @click="submitForm('ruleForm2')" style="width: 100%" :disabled="!ruleForm2.agree">注册</el-button>
					</el-form-item>
					<el-form-item>
						<p class="login" @click="gotoLogin">已有账号？立即登录</p>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import accountApi from '@/api/account'
import { baseUrl } from '../config'

export default {
	data() {
		// <!--验证地址-->
		let checkcontact_address = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入联系地址'))
			} else {
				callback()
			}
		}
		// <!--验证昵称->
		let checkName = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入昵称'))
			} else {
				callback()
			}
		}
		//验证团队id
		let checkdomain = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输团队ID'))
			} else if (!this.testDomain(value)) {
				callback(new Error('输入值需要2-32位英文或数字'))
			} else {
				callback()
			}
		}
		//验证公司名称
		let checkfull_name = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入公司名称'))
			} else {
				callback()
			}
		}
		//  <!--验证码是否为空-->
		let checkSmscode = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入验证码'))
			} else {
				callback()
			}
		}
		// <!--验证邮箱-->
		let validateEmail = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请输入邮箱'))
			} else if (!this.checkEmail(value)) {
				callback(new Error('邮箱格式不正确'))
			} else {
				callback()
			}
		}
		return {
			captchaSrc: baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime(),
			captcha: '',
			contact_phone: '16621678619',
			account: 'liuxing@jiagouyun.com',
			name: '',
			ruleForm2: {
				contact_address: '',
				smscode: '',
				name: '',
				domain: '',
				full_name: '',
				email: '',
				agree: false,
			},
			rules2: {
				full_name: [
					{
						validator: checkfull_name,
						trigger: 'change',
					},
				],
				domain: [
					{
						validator: checkdomain,
						trigger: 'change',
					},
				],
				contact_address: [
					{
						validator: checkcontact_address,
						trigger: 'change',
					},
				],
				smscode: [
					{
						validator: checkSmscode,
						trigger: 'change',
					},
				],
				name1: [
					{
						validator: checkName,
						trigger: 'change',
					},
				],
				email: [
					{
						validator: validateEmail,
						trigger: 'change',
					},
				],
			},
			buttonText: '获取验证码',
			flag: true,
		}
	},
	methods: {
		// <!--提交注册-->
		submitForm(formName) {
			let content = {
				captcha: this.ruleForm2.smscode,
				company: {
					domain: this.ruleForm2.domain,
					email: this.ruleForm2.email,
					full_name: this.ruleForm2.full_name,
					contact_name: this.ruleForm2.name,
					contact_address: this.ruleForm2.contact_address,
					contact_phone: this.ruleForm2.tel,
				},
				account: {
					account: this.ruleForm2.email,
					name: this.ruleForm2.name,
				},
			}
			accountApi
				.register(content)
				.then((res) => {
					this.$notify({
						message: this.$gettext('Register Successfully!'),
						type: 'success',
					})
					this.$router.push('/login')
					this.ruleForm2 = this.$options.data().ruleForm2
				})
				.catch((err) => {
					this.$notify({
						message: this.$gettext('Register failed!'),
						type: 'error',
					})
				})
			this.refresh()
		},

		// <!--进入登录页-->
		gotoLogin() {
			this.$router.push({
				path: '/login',
			})
		},
		//验证邮箱
		checkEmail(str) {
			let re = /^[A-Za-z0-9\u4e00-\u9fa5]+([._\\-]*[A-Za-z0-9\u4e00-\u9fa5])*@[A-Za-z0-9_-\u4e00-\u9fa5]+(\.[A-Za-z0-9_-\u4e00-\u9fa5]+)+$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},
		// 正则校验团队id
		testDomain(str) {
			let re = /^[0-9A-Za-z]{2,32}$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},
		refresh() {
			this.captchaSrc = baseUrl.apiUrl + '/auth/captcha' + '?' + new Date().getTime()
		},
	},
}
</script>

<style scoped>
.code img {
	position: absolute;
	right: 0px;
}

.register-wrapper .el-form-item__content {
	line-height: 36px;
	position: relative;
	font-size: 14px;
	display: flex;
}

.register-wrapper .loading-wrapper {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: #aedff8;
	display: flex;
	align-items: center;
	justify-content: center;
}

.register-wrapper {
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
}

#register {
	max-width: 445px;
	margin: 60px auto;
	background: #fff;
	padding: 20px 80px;
	border-radius: 10px;
	position: relative;
	z-index: 9;
}

.register-wrapper .title {
	font-size: 26px;
	line-height: 50px;
	font-weight: bold;
	margin: 10px;
	text-align: center;
}

.register-wrapper .el-form-item {
	text-align: center;
}

.register-wrapper .login {
	margin-top: 10px;
	font-size: 14px;
	line-height: 22px;
	color: #1ab2ff;
	cursor: pointer;
	text-align: left;
	text-indent: 8px;
	width: 160px;
}

.login:hover {
	color: #2c2fd6;
}

.register-wrapper .code >>> .el-form-item__content {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.register-wrapper .code button {
	margin-left: 20px;
	width: 140px;
	text-align: center;
}

.register-wrapper .el-button--primary:focus {
	/* background: #f60; */
	/* border-color: #f60; */
	background: #409eff;
	border-color: #409eff;
	color: #fff;
}

.register-wrapper .agree {
	margin-bottom: 5px;
	font-size: 12px;
	a {
		color: #0069ff;
	}
}
</style>



// WEBPACK FOOTER //
// register.vue?5409256f